import { redirectUrl } from './redirectUrl'
import { iframeHtml } from './iframeHtml'
import { redirectHtml } from './redirectHtml'
import { repeatedRequest } from './repeatedRequest'
import { redirectScript } from './redirectScript'
import { setStorageHash } from './setStorageHash'

export const routerThreeDsV3 = data => {
  const action = data.action
  const actionName = data.action.name
  const actionHash = data.action.hash
  const actionValue = data.action.value

  let md5hash = ''

  try {
    if (localStorage.getItem('md5hash') !== null) {
      md5hash = localStorage.getItem('md5hash')
    }
  } catch (e) {
    console.error('getMD5: ' + e)
  }

  //----------------- redirect_url ----------------

  if (action && actionName === 'redirect' && md5hash !== actionHash) {
    redirectUrl(actionValue)
    setStorageHash(actionHash)

    return
  } else if (action && actionName === 'redirect' && md5hash === actionHash) {
    setTimeout(function () {
      repeatedRequest()
    }, 3000)

    return
  }

  //----------------- redirect_Script ----------------

  if (action && actionName === 'script' && md5hash !== actionHash) {
    redirectScript(actionValue)
    setStorageHash(actionHash)

    return
  } else if (action && actionName === 'script' && md5hash === actionHash) {
    setTimeout(function () {
      repeatedRequest()
    }, 3000)

    return
  }

  //-------------- html -------------------

  if (action && actionName === 'html' && md5hash !== actionHash) {
    redirectHtml(actionValue)
    setStorageHash(actionHash)

    return
  } else if (action && actionName === 'html' && md5hash === actionHash) {
    setTimeout(function () {
      repeatedRequest()
    }, 2500)

    return
  }

  //--------------- iframe_html ------------------

  if (action && actionName === 'iframe' && md5hash !== actionHash) {
    setStorageHash(actionHash)
    console.log('actionHash: ' + actionHash)
    console.log('md5hash: ' + md5hash)
    iframeHtml(actionValue)

    return
  } else if (action && actionName === 'iframe' && md5hash === actionHash) {
    setTimeout(function () {
      repeatedRequest()
    }, 3000)

    return
  }

  //------------- if empty -------------------

  if ((action && actionName === '') || (action && actionName === null) || (action && actionName === undefined)) {
    setTimeout(function () {
      repeatedRequest()
    }, 2500)
  }
}
